<template>
  <div class="direct-wrap">
    <div class="table-wrap">
      <div class="table-header">
        <span class="header-text">共 20 条数据</span>
        <el-input
          placeholder="请输入广告投放账号"
          suffix-icon="el-icon-search"
          v-model="searchStr"
          style="width: 160px"
        >
        </el-input>
      </div>
      <el-table :data="[{}]" style="width: 100%" height="calc(100vh - 200px)">
        <el-table-column prop="date" label="定向包名称"> </el-table-column>
        <el-table-column prop="date" label="关联计划数"> </el-table-column>
        <el-table-column prop="date" label="创建时间"> </el-table-column>
        <el-table-column label="操作" width="120">
          <template>
            <el-button type="text" size="small" @click="showDetailModal"
              >查看</el-button
            >
            <el-button type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 详情弹框 -->
    <detail-modal ref="detailModalRef"></detail-modal>
    <!-- 计划弹框 -->
    <plan-list-modal ref="planListRef"></plan-list-modal>
  </div>
</template>

<script>
import DetailModal from "./detailModal.vue";
import PlanListModal from "./planList.vue";
export default {
  name: "directionalPkg",
  data() {
    return {
      searchStr: "",
    };
  },
  components: {
    DetailModal,
    PlanListModal,
  },
  methods: {
    showDetailModal() {
      this.$refs.detailModalRef.showModal();
    },
  },
};
</script>

<style lang='less' scoped>
.direct-wrap {
  padding: 16px;
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    margin-top: 16px;
    padding: 16px 24px;
    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      .header-text {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 14px;
      }
    }
  }
}
</style>